<div class="mainImage"></div>

<div class="container-fluid">
  <h1>What does it mean to be Plan Managed?</h1>
  <br>
  <p>
    When it comes to managing the funding in your NDIS plan, there are three options the NDIA may offer you:
  </p>

  <ul>
    <li>Agency-managed</li>
    <li>Self-managed</li>
    <li>Plan-managed</li>
  </ul>


  <br />
  <div class="background">
    <p>
      <strong>Agency-managed</strong> means that the NDIA will pay your providers. This means:
    </p>

    <ul>
      <li>You can choose from a range of NDIS registered providers.</li>
      <li>Your providers will claim payment from your funding.</li>
      <li>The providers you choose must be registered with the NDIS. You cannot use unregistered providers.</li>
      <li>You can check the myplace portal to see what claims providers are making against your NDIS funding to keep
        track of your budget.</li>
      <li>The NDIA will manage your book-keeping and records of your spending.</li>
    </ul>
  </div>
  <br />
  <div class="background">
    <p><strong>Self-managed</strong> means that you will have:</p>

    <ul>
      <li>Choice in deciding what supports you purchase in line with what is included in your plan, who provides these
        supports and how they are delivered.</li>
      <li>Flexibility to use any provider that will best help you to meet your plan goals.</li>
      <li>Capacity to employ or contract staff directly, or have someone employ staff on your behalf.</li>
      <li>Ability to negotiate the costs of your supports so you get the best value-for-money and to use savings to buy
        more or better quality supports.</li>
      <li>Control over and responsibility for your NDIS funding so you can manage your own budget for the duration of
        your plan.</li>
    </ul>

    <p>
      However, self-managing your plan does come with responsibilities also which include:
    </p>

    <ul>
      <li>Purchasing supports that link to the goals in your NDIS plan.</li>
      <li>Having service agreements with your providers about the supports you will receive including how they will be
        provided and paid for.</li>
      <li>Managing your funding so the costs of the support give you value-for-money, and can be met within your budget.
      </li>
      <li>Claiming and paying for supports by making payment requests and paying for your supports on time.</li>
      <li>Keeping invoices and receipts to show you have paid for your supports using your NDIS funding.</li>
      <li>Meeting your obligations as an employer if you choose to employ staff directly.</li>
      <li>Showing how you've used your self-managed funding towards reaching your goals at your plan review.</li>
      <li>Advising the NDIA of any significant changes in your circumstances that may result in you being unable to meet
        your responsibilities as a self-manager.</li>
      <li>Participating in any payment auditing where you will need to provide invoices, receipts or other evidence to
        show you have spent your funds in-line with your NDIS plan.</li>
    </ul>
  </div>
  <br />
  <div class="background">
    <p>
      <strong>Plan-managed</strong> means an NDIS registered Plan Manager takes
      care of your plan. This allows you to:
    </p>

    <ul>
      <li>Use genuine providers that may not be registered with the NDIS.</li>
      <li>Pay your providers for the supports you purchase.</li>
      <li>Help you keep track of your funds.</li>
      <li>Take care of financial reporting for you.</li>
    </ul>

    <p>
      NDIS Plan Managers must be a registered provider and will be funded in your plan. They claim directly from the
      budgets in your plan to pay your providers on your behalf.
    </p>
  </div>

  <br />

  <p>
    Your plan can be managed in any of these ways and you can even choose a combination of the three options:
    <br>
    i.e. You can have the NDIA manage the payments of your accommodation and have your plan manager look after your core
    budgets.
  </p>
  <p>
    ADIEM believes plan management is the best option as it gives you the flexibilty of being self-managed whilst taking
    care of all the claiming, provider payments and financial reporting as if you were agency-managed. Best of all, the
    funding for plan management doesn't come out of your funding but instead is <u>added</u> to your funding.
  </p>
</div>